import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BrokerPortfolioStatusesEnum, DashFeaturesEnum } from 'dash-common';
import {
  Flex,
  Icon,
  ModalContext,
  Text,
  useCheckIfSubscriptionFeatureActiveBroker,
} from 'dash-ui';
import { PortfolioFragment } from 'gql/generated.graphql';

import {
  PORTFOLIO_STATUSES_OPTIONS,
  PORTFOLIO_STATUSES_OPTIONS_PASSWORD,
} from './PortfolioStatusLabel.constants';

const PortfolioStatusLabel = ({
  portfolio,
}: {
  portfolio: PortfolioFragment;
}) => {
  const { t } = useTranslation(['pages']);
  const { toggleModal, setPayload } = useContext(ModalContext);
  const status = portfolio.status as BrokerPortfolioStatusesEnum;
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING,
  ]);
  const { icon, color } = portfolio.withPassword
    ? PORTFOLIO_STATUSES_OPTIONS_PASSWORD
    : PORTFOLIO_STATUSES_OPTIONS[status];

  return (
    <Flex
      flex={1}
      onClick={(e) => {
        e.stopPropagation();
        if (checkFeatureAccess()) {
          toggleModal(true, 'SharePortfolioModal');
          setPayload({ portfolio });
        }
      }}
      alignItems="center"
      justifyContent="center"
    >
      <Icon mr={1.25} name={icon} color={color} />
      <Text color={color} cursor="pointer">
        {t(`portfoliosPage.statuses.${portfolio.status}`)}
      </Text>
    </Flex>
  );
};

export default PortfolioStatusLabel;
